import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios.js';
//import { useAuth } from 'contexts/AuthContext';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Toolbar, useMediaQuery,Button} from '@mui/material';
import Alert from '@mui/material/Alert';
// project import
import Drawer from './Drawer';
import Header from './Header';
import navigation from 'menu-items';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import Typography from '@mui/material/Typography';
//import CloseOutlined from '@mui/icons-material/CloseOutlined';
// types
import { openDrawer } from 'store/reducers/menu';

// ==============================|| MAIN LAYOUT ||============================== //

function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

const MainLayout = () => {

  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));
  const dispatch = useDispatch();


  const { drawerOpen } = useSelector((state) => state.menu);

  // Set User To localstorage
  //const { user, setUser } = useAuth();

  // drawer toggler
  const [open, setOpen] = useState(drawerOpen);
 // const [redirect,setRedirect]=useState(false);
  const handleDrawerToggle = () =>
  {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  // set media wise responsive drawer
  useEffect(() => {
    setOpen(!matchDownLG);
    dispatch(openDrawer({ drawerOpen: !matchDownLG }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

    // const [AdminUserID]=useState(localStorage.getItem('AdminUserID'))
    // const [UserID]=useState(localStorage.getItem('id'))
    const Plans=JSON.parse(localStorage.getItem("Plans"))
    const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');

    // Load User plan
    const [IsMakePaymentButtonEnabled, setIsMakePaymentButtonEnabled] = useState(false)
    const [IsPlanAlertShow, setIsPlanAlertShow] = useState(false)
    const [UserDetails] = useState(JSON.parse(localStorage.getItem("Plans")))

    useEffect(() => {
        // UserDetails can be null if "Plans" hasn't been written to localStorage yet -
        // guard so this layout (and everything rendered through <Outlet />) doesn't crash
        if (!UserDetails) return;

        setIsMakePaymentButtonEnabled(UserDetails.IsMakePaymentButtonEnabled);
        if(UserDetails.IsActivePlan===0)
        {
            setIsPlanAlertShow(true)
        }

    }, [IsMakePaymentButtonEnabled]);


      const handlePayment = async () =>
        {
            setLoading(true);
            setError('');

            const scriptLoaded = await loadRazorpayScript();
            if (!scriptLoaded) {
            setError('Failed to load Razorpay. Check your connection and try again.');
            setLoading(false);
            return;
            }
            // get Details

            try {
                // Step 1: create order on backend - amount is derived server-side from plan.id, never trust client amount
                const { data: orderData } = await axios.post('/payment-create-order', {
                    plan_id: Plans.PlanID,
                    name: localStorage.getItem("name"),
                    email: localStorage.getItem("email"),
                    mobile_number: localStorage.getItem("mobilenumber"),
                    Price:Plans.Price,
                    UserID:localStorage.getItem("AdminUserID"),
                    tenant:localStorage.getItem("tenant"),
                    UserSubscribedPlanID:Plans.UPlanID, // Subscribed Planid
                    RePayment:1,
                    RepaymentPlanID:Plans.id
                });

                // Step 2: open Razorpay Checkout
                const options = {
                    key: orderData.key,
                    amount: orderData.amount,
                    currency: orderData.currency,
                    order_id: orderData.order_id,
                    name: 'Sterling Systems Pvt. Ltd.',
                    description: `Payment for KiT ${Plans.PlanName}`,
                    prefill: {
                    name: localStorage.getItem("name"),
                    email: localStorage.getItem("email"),
                    contact: localStorage.getItem("mobilenumber")
                    },
                    theme: { color: '#3399cc' },
                    handler: async function (response) {
                    try {
                        // Step 3: verify on backend
                        const { data: verifyData } = await axios.post('/verify-payment', {
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature
                        });

                        if (verifyData.success) {
                            //navigate('/otp-verification', { state: { user } });
                            setLoading(false);
                            window.location.href = '/dashboard';
                        } else {
                        setError('Payment verification failed. Please contact support.');
                        }
                    } catch (verifyErr) {
                        setError('Payment verification failed. Please contact support.');
                    }
                    },
                    modal: {
                        ondismiss: async function () {

                            try
                            {
                                await axios.post('/payment-cancelled', {
                                    order_id: orderData.order_id,      // from Step 1 response, available via closure
                                    tenant: localStorage.getItem("tenant")
                                });

                            }
                            catch (cancelErr)
                            {
                                console.log("Payment Cancellation update failed -");
                                console.log(cancelErr);
                            }

                            setError('Payment was cancelled.');
                            //setLoading(false);
                        }
                    }
                };

                const rzp = new window.Razorpay(options);
                rzp.on('payment.failed', async function (response) {
                    try {
                        await axios.post('/payment-failed', {
                            order_id: response.error.metadata.order_id,
                            payment_id: response.error.metadata.payment_id,
                            reason: response.error.description,
                            tenant: localStorage.getItem("tenant")
                        });

                    }
                    catch (failErr)
                    {
                        console.log(failErr);
                    }

                    setError(`Payment failed: ${response.error.description}`);
                    setLoading(false);
                });
                rzp.open();
            }
            catch (err)
            {
                console.log(err);
                setError('Could not start payment. Please try again.');
                setLoading(false);
            }
        };


  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />
      <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
      <Box component="main" sx={{ width: '100%', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar />

            <Breadcrumbs navigation={navigation}  />

            {
                IsPlanAlertShow===true ? <Alert  variant="filled" severity="error">
                <Typography variant='h6'> Your plan validity has expired! Please upgrade your plan!</Typography>
                </Alert> : ''
            }

            {Boolean(IsMakePaymentButtonEnabled) && (
                <Button
                    variant="contained"
                    color="success"
                    disabled={loading}
                    onClick={handlePayment} className="btn-primary fs-16 btn-md"
                >
                    {loading ? 'Processing…' : 'Complete Payment against Failed/cancelled transaction'}
                </Button>
            )}

        <Outlet />
      </Box>

    </Box>
  );
};

export default MainLayout;
